// extracted by css-extract-rspack-plugin
export default {"item":"_19e8f3fc"};